import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import ListLinkBox from '../../../../components/UI/ListLinkBox';
import { translate } from '../../../../utils/util';
import BackButton from '../../../../components/UI/BackButton';
import * as actionsStock from '../../../../actions/stockAction';

const ChangeLocation = (props) => {
    const menu = () => {
        let menuItems = [];

        menuItems = [...menuItems, { route: 'location/reading', icon: 'mdi mdi-location-enter', text: translate('change-location:menu.changeLocation') }];

        menuItems = [...menuItems, {
            route: {
                pathname: 'stock/search',
                state: {
                    twoSteps: true
                }
            }, icon: 'mdi mdi-arrange-send-backward', text: `${translate('change-location:menu.changeLocation')} Duas Etapas`,
        }];

        menuItems = [...menuItems, { route: 'location/reprint', icon: 'printer', text: translate('physical-confirmation:reprint') }];
        menuItems = [...menuItems, { route: 'location/upload', icon: 'mdi mdi-file-upload', text: translate('change-location:menu.upload') }];
        menuItems = [...menuItems, { route: 'location/reprocesssearch', icon: 'mdi mdi-monitor', text: translate('reprocess-monitor', 'physical-confirmation') }];
        menuItems = [...menuItems, { route: 'location/logtransmission', icon: 'mdi mdi-monitor', text: translate('log-transmission-title', 'change-location') }];
        menuItems = [...menuItems, { route: 'location/report/home', icon: 'mdi mdi-clipboard-list-outline', text: translate('change-location:menu.report') }];
        menuItems = [...menuItems, { route: 'location/areaconversion/home', icon: 'mdi mdi-format-horizontal-align-center', text: translate('area-conversion', 'physical-confirmation') }];
        menuItems = [...menuItems, { route: 'location/massivechange', icon: 'mdi mdi-vector-polyline-plus', text: translate('massive-change-location', 'change-location') }];
        menuItems = [...menuItems, { route: 'location/cimmassivechange', icon: 'mdi mdi-arrange-send-to-back', text: "Troca de Locação Massiva por CIM" }];

        return menuItems;
    };

    return (
        <div>
            <BackButton {...props} />
            <div className="container-fluid h-65">
                <div className="row">
                    <div className="title">
                        <i className="mdi mdi-clipboard-check-outline" />
                        {translate('change-location:menu.changeLocation')}
                    </div>
                </div>
            </div>
            <div className="container" style={{ marginLeft: '5px', marginTop: '40px', }}>
                <ListLinkBox
                    options={menu()}
                />
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        clear: () => {
            dispatch(actionsStock.clearMaterials());
            dispatch(actionsStock.clearFilter());
        }
    };
};
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withRouter(withTranslation()(ChangeLocation))));

